class ProductCardSlider extends HTMLElement {
  static get observedAttributes() {
    return ['data-initialized'];
  }

  constructor() {
    super();
    this.elements = {
      track: this.querySelector('[data-product-card-slider-el="track"]'),
      progress: this.querySelector('[data-product-card-slider-el="progress"]'),
      thumb: this.querySelector('[data-product-card-slider-el="thumb"]'),
      nextButton: this.querySelector('[data-product-card-slider-el="next"]'),
      prevButton: this.querySelector('[data-product-card-slider-el="prev"]')
    }

    if (!this.elements.track || !this.elements.progress || !this.elements.thumb || !this.elements.nextButton || !this.elements.prevButton) {
      console.error('One or more required elements are missing');
      return;
    }

    this.state = {
      scrollPercentage: 0,
      numberOfSlides: 0
    }
  }

  connectedCallback() {
    if(this.getAttribute('data-initialized') === 'true') {
      this.attachEventListeners();
      this.findNumberOfSlides();
      this.render();
    }
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-initialized' && newValue === 'true') {

      this.attachEventListeners();
      this.findNumberOfSlides();
      this.render();
    }
  }

  /**
  * Attaches event listeners to the track and navigation buttons.
  */
  attachEventListeners() {
    this.elements.track.addEventListener('scroll', () => this.handleScroll());
    this.elements.nextButton.addEventListener('click', (e) => this.next(e));
    this.elements.prevButton.addEventListener('click', (e) => this.prev(e));
  }

  render() {
    const FULL_PERCENTAGE = 100;

    if (this.elements.thumb) {
      this.elements.thumb.style.width = FULL_PERCENTAGE / this.state.numberOfSlides + '%';
      const leftPosition = this.state.scrollPercentage * (FULL_PERCENTAGE - (FULL_PERCENTAGE / this.state.numberOfSlides)) / FULL_PERCENTAGE;
      this.elements.thumb.style.left = leftPosition + '%';
    }

    if (this.elements.nextButton && this.elements.prevButton) {
      const atStart = this.state.scrollPercentage === 0;
      const atEnd = this.state.scrollPercentage === FULL_PERCENTAGE;

      this.elements.prevButton.disabled = atStart;
      this.elements.nextButton.disabled = atEnd;

      if (atStart) {
        this.elements.prevButton.classList.remove('visible');
      } else {
        this.elements.prevButton.classList.add('visible');
      }

      if (atEnd) {
        this.elements.nextButton.classList.remove('visible');
      } else {
        this.elements.nextButton.classList.add('visible');
      }
    }
  }

  next (e) {
    e.preventDefault()
    this.requestLazyLoadedSlides()
    this.elements.track.scrollLeft += this.elements.track.clientWidth
  }

  prev (e) {
    e.preventDefault()
    this.elements.track.scrollLeft -= this.elements.track.clientWidth
  }

  requestLazyLoadedSlides () {
    const event = new CustomEvent('product-card:lazy-load-slides', {
      bubbles: true,
      cancelable: true
    })

    this.dispatchEvent(event)
  }

  set scrollPercentage (percentage) {
    this.state.scrollPercentage = percentage
    this.setAttribute('data-scroll-percentage', percentage)

    this.render()
  }

  set numberOfSlides (number) {
    this.state.numberOfSlides = number
  }

  findNumberOfSlides () {
    this.numberOfSlides = this.elements.track.children.length
  }

  handleScroll () {
    this.requestLazyLoadedSlides()
    this.calculateScrollPercentage()
  }

  calculateScrollPercentage () {
    this.scrollPercentage = this.elements.track.scrollLeft / (this.elements.track.scrollWidth - this.elements.track.clientWidth) * 100
  }
}

customElements.define('product-card-slider', ProductCardSlider)
